"use client";
import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import DOMPurify from 'dompurify';
import useRefferalHook from "../../../hooks/useRefferal.hook";
import { ContextData, storeAssigned } from "@/services/Methods/normalMethods";
import Loader from "@/comman/Loader";
import UseAdminPortal from "../../../hooks/UseAdminPortal.hook";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import localStorageCall from "@/services/Methods/localstorage.hook";
import ButtonComponent from "@/Inputs/ButtonComponent";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';


const Home = (props) => {
  const [playVideos, setPlayVideos] = useState({});
  const [iPPopupOpen, setIPPopupOpen] = useState(true);

  const data = useContext(ContextData);
  const { setSelectedStore } = data;
  const { isReferralLoading, handleCloseShareIPPopup } = useRefferalHook({ ...props, ...data }, 'urlRefferalCheck');
  const { getFrontEndBanners, FrontendBanners } = UseAdminPortal();
  useEffect(() => {
    getFrontEndBanners();
  }, []);

  const handlePlayVideo = (id) => {
    setPlayVideos((prev) => ({ ...prev, [id]: true }));
  };
  const sanitizeHtml = (html) => {
    return DOMPurify.sanitize(html, {
      ADD_TAGS: ["style"], // Allow <style> tags
      ADD_ATTR: ["class", "style"], // Allow style attributes
    });
  };
  const ShareRedirectToCountry = localStorageCall().getSingleItem('shareRedirectToCountry');
  const isIPCheckPopupOpen = localStorageCall().getSingleItem("isIPCheckPopupOpen") === 'true';
  return (
    isReferralLoading ? (
      <Loader />
    ) : (
      <div className="main main-slider-section-cstm" style={{ backgroundColor: "black" }}>
        <Swiper
          className="slider_inner"
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50}
          slidesPerView={1}
          navigation={true}
          pagination={{ clickable: true }}
        >
          {FrontendBanners?.map((file, index) => (
            <SwiperSlide key={file.id}>
              <div className="lg:max-w-[1920px] mx-auto z-[2] flex flex-wrap flex-row-reverse">
                <div className="video_inner lg:w-1/2 w-full flex items-center justify-center 2xl:min-h-[630px] xl:min-h-[520px] md:min-h-[590px] min-h-[320px]">
                  {file.video_url ? (
                    !playVideos[file.id] ? (
                      <div
                        className="video-thumbnail w-full h-full bg-cover bg-center relative"
                        style={{ backgroundImage: `url(${file.image_url})` }}
                        onClick={() => handlePlayVideo(file.id)}
                      >
                        <button
                          onClick={() => handlePlayVideo(file.id)}
                          className="absolute w-[150px] h-[150px] rounded-full flex items-center justify-center text-black text-2xl font-bold"
                          style={{
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        >
                          <img src="/images/PlayArrow.png" alt="Play" />
                        </button>
                      </div>
                    ) : (
                      <figure className="lg:flex-1 block h-full max-xsm:max-w-[300px] max-xsm:mx-auto">
                        <iframe
                          src={file.video_url}
                          style={{ width: "100%", height: "100%" }}
                          allow="autoplay; fullscreen"
                          allowFullScreen
                          className="w-full h-full"
                        ></iframe>
                      </figure>
                    )
                  ) : (
                    <img
                      src={file.image_url}
                      alt="Slide"
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>

                <div
                  className="lg:flex-1 text-white lg:p-[144px_72px_144px_72px] p-[21px_20px_76px_20px] text-[28px] lg:w-1/2 relative flex flex-col lg:justify-center lg:items-start items-center slider-content-with-bg w-full"
                  style={{
                    backgroundImage: `url(${file.image_url})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div
                    className="z-[2] lg:text-start text-center"
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(file.link_url) }}
                  ></div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div>
          {isIPCheckPopupOpen && (ShareRedirectToCountry !== storeAssigned()) && iPPopupOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-md">
                {/* {
                  isUserLogin && UserCountry !== storeAssignUppercase && (
                    <p className="text-gray-800 text-center mb-4">
                      The Country on your account ({UserCountry}) does not match the store you are shopping ({storeAssign}).
                    </p>
                  )
                } */}
                {
                  ShareRedirectToCountry !== storeAssigned() && (
                    <p className="text-gray-800 text-center mb-4">
                      {/* Your IP {storeAssigned()?.toUpperCase()} does not match the store you are shopping {ShareRedirectToCountry?.toUpperCase()}. */}
                      This cart was created on our {ShareRedirectToCountry?.toUpperCase()} site, but you are visiting from {storeAssigned()?.toUpperCase()}.

                    </p>
                  )
                }


                <p className="text-gray-800 text-center mb-4">
                  {/* Do you still want to continue with {storeAssigned()?.toUpperCase()}? */}
                  How would you like to proceed?
                </p>
                <div className="flex justify-center">
                  <button

                    onClick={() => {
                      setIPPopupOpen(false);
                      handleCloseShareIPPopup();
                    }}

                    style={{
                      padding: '0.5rem 1rem',
                      // backgroundColor: '#8dfa00',
                      // color: 'white',
                      borderRadius: '0.5rem',
                      // transition: 'background-color 0.2s ease',
                    }}

                    className="px-4 py-2 text-black rounded-lg border-[#8dfa00] bg-[#8dfa00]"
                  >
                    Continue to the {storeAssigned()?.toUpperCase()} site
                  </button>
                  {/* (Items will be moved to a new cart, if available) */}
                </div>
                <div className="text-base/7 font-medium text-[#591069] mb-2 text-center">
                  OR
                </div>

                <div>
                  <ButtonComponent

                    onClick={() => {
                      setSelectedStore((prv) => ({ newCode: ShareRedirectToCountry, defaultCode: ShareRedirectToCountry }))
                      localStorageCall().setItem('store', ShareRedirectToCountry);
                      setIPPopupOpen(false);
                      handleCloseShareIPPopup();
                      // window.location.assign(`/${storeAssigned()}`)
                    }}>
                    {/* Change {storeAssigned()?.toUpperCase()} <ArrowRightAltIcon />  {ShareRedirectToCountry?.toUpperCase()} */}
                    View on the {ShareRedirectToCountry?.toUpperCase()} site
                  </ButtonComponent>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  );
};
export default Home;